"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createRange_1 = require("./createRange");
/**
 * Restore inner Html of a root element from given html string. If the string contains selection path,
 * remove the selection path and return a range represented by the path
 * @param root The root element
 * @param html The html to restore
 * @returns A selection range if the html contains a valid selection path, otherwise null
 */
function setHtmlWithSelectionPath(rootNode, html) {
    rootNode.innerHTML = html || '';
    var path = null;
    var pathComment = rootNode.lastChild;
    try {
        path =
            pathComment &&
                pathComment.nodeType == 8 /* Comment */ &&
                JSON.parse(pathComment.nodeValue);
        if (path && path.end && path.end.length > 0 && path.start && path.start.length > 0) {
            rootNode.removeChild(pathComment);
        }
        else {
            path = null;
        }
    }
    catch (_a) { }
    return path && createRange_1.default(rootNode, path.start, path.end);
}
exports.default = setHtmlWithSelectionPath;
//# sourceMappingURL=setHtmlWithSelectionPath.js.map